import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-component',
  templateUrl: './menu-component.component.html',
  styleUrls: ['./menu-component.component.css']
})
export class MenuComponentComponent implements OnInit {
  menuOpened: false;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /home/claudio/Projects/thebatclaudio.github.io/src/app/menu-component/menu-component.component.ts